// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  background-color: #84a59d;
}

.App-component {
  margin-bottom: -100rem;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

 /* Header */
.App-header {
  background-color: #f1cbc6;
  min-height: 30vh;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: calc(10px + 2vmin);
  color: white;
  border-bottom-style: solid;
  border-bottom-width: 3px;
  border-bottom-color: black;
}

.App-header-name {
  color: #84a59d;
  margin-left: 1rem;
  display: inline-block;
  flex-direction: column;
  margin-top: -3rem;
  margin-bottom: 1rem;
}

.App-header-name-text {
  margin-top: -0.1rem;
  margin-bottom: -0.5rem;
}

.App-header-nav {
  text-decoration: none;
}

 /* About page */
.App-bio {
  display: flex;
  flex-direction: row;
  text-align: left;
}

.App-bio-text {
  color: #f1cbc6;
  padding: 5rem;
  margin-top: -1.5rem;
  font-size: 2rem;
}

.App-bio-image {
  max-height: 60vh;
  max-width: 55vh;
  margin-top: 1rem;
  margin-right: 5rem;
  margin-bottom: 5rem;
}

 /* Work page */
.App-work-block {
  margin-bottom: 10rem;
}

.App-work-h1 {
  color: #f1cbc6;
  font-size: 6rem;
  margin-left: -20rem;
}

.App-work-h2 {
  font-size: 2rem;
  margin-top: -7rem;
  margin-left: -12rem;
}

.App-work-subtitle {
  margin-left: 20rem;
  margin-right: 5rem;
  text-align: left;
  font-style: italic;
}

.App-work-para {
  margin-left: 20rem;
  margin-right: 5rem;
  text-align: left;
  font-weight: 700;
}

.App-work-link {
  color: #000000;
}

 /* Contact page */
.App-contact {
  color: #f1cbc6;
  display: flex;
  flex-direction: row-reverse;
  text-align: left;
  margin-right: 2rem;
  margin-top: -2rem;
}

.App-contact-links {
  padding-bottom: 2rem;
}

.App-contact-para {
  color: #f1cbc6;
  font-size: 2rem;
  margin-left: 4rem;
  margin-top: 10rem;
}

.Link-text {
  text-decoration: none;
  color: #f1cbc6;
  text-align: left;
}

.Link-text-big {
  font-size: 6rem;
  margin-left: 2rem;
}

.Link-text-small {
  color: #000000;
  font-size: 2rem;
  margin-top: -7rem;
  margin-left: 5rem;
  font-weight: bold;
}

.App-link {
  color: #000000;
  justify-content: space-between;
  padding: 1em;
  margin-right: 2rem;
  text-decoration: none;
  font-weight: bold;
}

.App-link:active {
  text-decoration: underline;
}

.App-not-found-page {
  padding-bottom: 20rem;
  padding-left: 5rem;
  padding-right: 5rem;
}

@media (max-width: 800px){
  .App {
    text-align: center;
    background-color: #f1cbc6;
  }
  
  .App-component {
    padding-bottom: 5rem;
  }

  /* Header */
  .App-header {
    background-color: #84a59d;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }

  .App-header-name {
    color: #f1cbc6;
    margin-left: -8rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 4rem;
    margin-top: -3rem;
    margin-bottom: 1rem;
  }
  
  .App-header-name-text {
    margin-top: -0.1rem;
    margin-bottom: -0.5rem;
    padding: 0.5rem;
  }

  .App-header-nav {
    margin-left: -2rem;
  }

  /* About page */
  .App-bio {
    display: flex;
    flex-direction: row;
    text-align: left;
    padding-bottom: 9rem;
  }
  
  .App-bio-text {
    color: #000000;
    padding-top: 5rem;
    padding-left: 2rem;
    margin-top: -1.5rem;
    font-size: 1.5rem;
    
  }
  
  .App-bio-image {
    display: none;
  }

    /* Work page */
  .App-work-block {
    margin-bottom: 12rem;
  }
  
  .App-work-h1 {
    color: #84a59d;
    font-size: 6rem;
    margin-left: -10rem;
    margin-top: 2rem;
  }
    
  .App-work-subtitle {
    margin-left: 2rem;
    margin-right: 5rem;
  }
    
  .App-work-para {
    margin-left: 2rem;
    margin-right: 5rem;
  }
    
  /* Contact page */
  .App-contact {
    color: #f1cbc6;
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-right: 2rem;
  }
  
  .App-contact-links {
    padding-top: 2rem;
    padding-bottom: 4rem;
  }
  
  .App-contact-para {
    display: none
  }
  
  .Link-text {
    text-decoration: none;
    color: #84a59d;
    text-align: left;
  }
  
  .Link-text-big {
    font-size: 5rem;
    margin-left: 1rem;
    margin-bottom: -3.2rem;
  }
  
  .Link-text-small {
    color: #000000;
    font-size: 1.6rem;
    margin-top: 2rem;
    margin-left: 1.4rem;
    margin-bottom: -1rem;
    font-weight: bold;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;CAEC,WAAW;AACZ;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;EAC7B,YAAY;EACZ,0BAA0B;EAC1B,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;CAEC,eAAe;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;CAEC,cAAc;AACf;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;CAEC,iBAAiB;AAClB;EACE,cAAc;EACd,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,oBAAoB;EACtB;;EAEA,WAAW;EACX;IACE,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,eAAe;EACf;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;;EAEnB;;EAEA;IACE,aAAa;EACf;;IAEE,cAAc;EAChB;IACE,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,iBAAiB;EACjB;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE;EACF;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;EACnB;AACF","sourcesContent":[".App {\n  text-align: center;\n  background-color: #84a59d;\n}\n\n.App-component {\n  margin-bottom: -100rem;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n /* Header */\n.App-header {\n  background-color: #f1cbc6;\n  min-height: 30vh;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  font-size: calc(10px + 2vmin);\n  color: white;\n  border-bottom-style: solid;\n  border-bottom-width: 3px;\n  border-bottom-color: black;\n}\n\n.App-header-name {\n  color: #84a59d;\n  margin-left: 1rem;\n  display: inline-block;\n  flex-direction: column;\n  margin-top: -3rem;\n  margin-bottom: 1rem;\n}\n\n.App-header-name-text {\n  margin-top: -0.1rem;\n  margin-bottom: -0.5rem;\n}\n\n.App-header-nav {\n  text-decoration: none;\n}\n\n /* About page */\n.App-bio {\n  display: flex;\n  flex-direction: row;\n  text-align: left;\n}\n\n.App-bio-text {\n  color: #f1cbc6;\n  padding: 5rem;\n  margin-top: -1.5rem;\n  font-size: 2rem;\n}\n\n.App-bio-image {\n  max-height: 60vh;\n  max-width: 55vh;\n  margin-top: 1rem;\n  margin-right: 5rem;\n  margin-bottom: 5rem;\n}\n\n /* Work page */\n.App-work-block {\n  margin-bottom: 10rem;\n}\n\n.App-work-h1 {\n  color: #f1cbc6;\n  font-size: 6rem;\n  margin-left: -20rem;\n}\n\n.App-work-h2 {\n  font-size: 2rem;\n  margin-top: -7rem;\n  margin-left: -12rem;\n}\n\n.App-work-subtitle {\n  margin-left: 20rem;\n  margin-right: 5rem;\n  text-align: left;\n  font-style: italic;\n}\n\n.App-work-para {\n  margin-left: 20rem;\n  margin-right: 5rem;\n  text-align: left;\n  font-weight: 700;\n}\n\n.App-work-link {\n  color: #000000;\n}\n\n /* Contact page */\n.App-contact {\n  color: #f1cbc6;\n  display: flex;\n  flex-direction: row-reverse;\n  text-align: left;\n  margin-right: 2rem;\n  margin-top: -2rem;\n}\n\n.App-contact-links {\n  padding-bottom: 2rem;\n}\n\n.App-contact-para {\n  color: #f1cbc6;\n  font-size: 2rem;\n  margin-left: 4rem;\n  margin-top: 10rem;\n}\n\n.Link-text {\n  text-decoration: none;\n  color: #f1cbc6;\n  text-align: left;\n}\n\n.Link-text-big {\n  font-size: 6rem;\n  margin-left: 2rem;\n}\n\n.Link-text-small {\n  color: #000000;\n  font-size: 2rem;\n  margin-top: -7rem;\n  margin-left: 5rem;\n  font-weight: bold;\n}\n\n.App-link {\n  color: #000000;\n  justify-content: space-between;\n  padding: 1em;\n  margin-right: 2rem;\n  text-decoration: none;\n  font-weight: bold;\n}\n\n.App-link:active {\n  text-decoration: underline;\n}\n\n.App-not-found-page {\n  padding-bottom: 20rem;\n  padding-left: 5rem;\n  padding-right: 5rem;\n}\n\n@media (max-width: 800px){\n  .App {\n    text-align: center;\n    background-color: #f1cbc6;\n  }\n  \n  .App-component {\n    padding-bottom: 5rem;\n  }\n\n  /* Header */\n  .App-header {\n    background-color: #84a59d;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-around;\n  }\n\n  .App-header-name {\n    color: #f1cbc6;\n    margin-left: -8rem;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    padding-top: 4rem;\n    margin-top: -3rem;\n    margin-bottom: 1rem;\n  }\n  \n  .App-header-name-text {\n    margin-top: -0.1rem;\n    margin-bottom: -0.5rem;\n    padding: 0.5rem;\n  }\n\n  .App-header-nav {\n    margin-left: -2rem;\n  }\n\n  /* About page */\n  .App-bio {\n    display: flex;\n    flex-direction: row;\n    text-align: left;\n    padding-bottom: 9rem;\n  }\n  \n  .App-bio-text {\n    color: #000000;\n    padding-top: 5rem;\n    padding-left: 2rem;\n    margin-top: -1.5rem;\n    font-size: 1.5rem;\n    \n  }\n  \n  .App-bio-image {\n    display: none;\n  }\n\n    /* Work page */\n  .App-work-block {\n    margin-bottom: 12rem;\n  }\n  \n  .App-work-h1 {\n    color: #84a59d;\n    font-size: 6rem;\n    margin-left: -10rem;\n    margin-top: 2rem;\n  }\n    \n  .App-work-subtitle {\n    margin-left: 2rem;\n    margin-right: 5rem;\n  }\n    \n  .App-work-para {\n    margin-left: 2rem;\n    margin-right: 5rem;\n  }\n    \n  /* Contact page */\n  .App-contact {\n    color: #f1cbc6;\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n    margin-right: 2rem;\n  }\n  \n  .App-contact-links {\n    padding-top: 2rem;\n    padding-bottom: 4rem;\n  }\n  \n  .App-contact-para {\n    display: none\n  }\n  \n  .Link-text {\n    text-decoration: none;\n    color: #84a59d;\n    text-align: left;\n  }\n  \n  .Link-text-big {\n    font-size: 5rem;\n    margin-left: 1rem;\n    margin-bottom: -3.2rem;\n  }\n  \n  .Link-text-small {\n    color: #000000;\n    font-size: 1.6rem;\n    margin-top: 2rem;\n    margin-left: 1.4rem;\n    margin-bottom: -1rem;\n    font-weight: bold;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
